/**
 * 单帧提交回传的 `styleName`(详情页「本次设置」展示用的短标签)。
 *
 * ═══ 为什么 V0 要动它 ═══════════════════════════════════════════════════════════
 * 本波给单帧补了 L2「配色」,它**真的改变出图**(渲成色板描述进【风格】段)。
 * 如果记录里只写画风,用户回详情页只看到「画风·科技AI未来」,
 * 自己选的那份配色一点痕迹都没有 —— 出图与记录两个出口只改了一个。
 *
 * ★只在**用户自己选过**配色时才记(`followStyle=false`):跟随态下配色是画风的函数,
 * 再写一遍是噪音。
 *
 * ★长度纪律:backend `styleName` 是 `@Size(80)`,超了直接「参数有误」。
 * `styleLabelForTone` 已把自定义画风截到 40,这里再兜一次总长 —— 单测锁死。
 */
import type { StyleTokens } from "../../longimage/model/canvas";
import { matchStyleTokenPreset } from "../../longimage/model/styleTokenPresets";
import { fontLabelForKey } from "../../ui/components/free-create/fontStyleOptions";
import { styleLabelForTone } from "../../ui/components/free-create/styleOptions";

/** backend `PosterTaskCreateRequest.styleName` 的 `@Size(80)`。 */
export const STYLE_NAME_MAX = 80;

export interface StyleNameInput {
  selectedStyle: string | null;
  fontStyle: string;
  styleTokens: StyleTokens | null;
  /** true = 配色跟着画风走(不单独记);false = 用户自己选过。 */
  followStyle: boolean;
}

export function buildStyleName(input: StyleNameInput): string | undefined {
  const font = fontLabelForKey(input.fontStyle);
  const palette = input.followStyle ? undefined : matchStyleTokenPreset(input.styleTokens)?.label;
  const name = [
    styleLabelForTone(input.selectedStyle),
    palette && `配色·${palette}`,
    font && `字体·${font}`,
  ]
    .filter(Boolean)
    .join(" / ");
  // 超长按字符裁 —— 宁可少一截也不要整个请求被 @Size 打回(风格是附加信息,不是主体)
  return name ? name.slice(0, STYLE_NAME_MAX) : undefined;
}
